import { inject } from '@angular/core';
import { DevincoConnectUserData } from '@core/auth/interfaces';
import { FeaturesService } from '@core/services/features.service';
import { TranslationService } from '@core/services/translation.service';
import { UserMetadataService } from '@core/services/user-metadata.service';
import { LocalStorageItems } from '@shared/constants/local-storage-item';
import { TranslationLanguage } from '@shared/constants/translation-lang';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { combineLatest, map, Observable, switchMap } from 'rxjs';

export const applicationMetaDataGuard = (): Observable<boolean> | boolean => {
  const translation = inject(TranslationService);
  const oidc = inject(OidcSecurityService);
  const userMetadataService = inject(UserMetadataService);
  const featuresService = inject(FeaturesService);

  return oidc.getUserData().pipe(
    switchMap((userData: DevincoConnectUserData) => {
      const lang =
        (localStorage.getItem(LocalStorageItems.Language) as
          | TranslationLanguage
          | undefined) || userData.lang;

      return translation.setTranslation(lang);
    }),

    switchMap(() =>
      combineLatest([
        userMetadataService.fetchClientName(),
        userMetadataService.fetchUserCountry(),
        userMetadataService.fetchUserDomains(),
        userMetadataService.fetchUserData(),
        featuresService.getFeatures(),
      ])
    ),

    map(() => true)
  );
};
